import React from 'react';

import CircleTick from 'components/Icons/CircleTick';

import { IconListItemProps } from '../interfaces';
import {
  TextWrapper,
  Content,
  HiddenCheckbox,
  Wrapper,
  IconContainer,
  TickIndicator,
  Pill
} from './styled';

const IconListItem = React.forwardRef<HTMLInputElement, IconListItemProps>(function IconListItem(
  {
    icon,
    label,
    primaryColor,
    secondaryColor,
    subLabel,
    selected,
    id,
    disabled,
    value,
    name,
    onChange,
    selectionType,
    iconSize,
    ...props
  },
  ref
) {
  return (
    <Wrapper {...props}>
      <HiddenCheckbox
        ref={ref}
        as='input'
        type={selectionType}
        value={value}
        id={id}
        name={name}
        disabled={disabled}
        onChange={onChange}
        checked={selected}
      />
      <Pill
        htmlFor={id}
        selected={selected}
        borderColor={primaryColor}
        backgroundColor={secondaryColor}>
        {!!selected && (
          <TickIndicator>
            <CircleTick fill={primaryColor} />
          </TickIndicator>
        )}
        <IconContainer iconSize={iconSize}>{icon}</IconContainer>
        <Content>
          <TextWrapper type='heading'>{label}</TextWrapper>
          {subLabel && <TextWrapper type='sub'>{subLabel}</TextWrapper>}
        </Content>
      </Pill>
    </Wrapper>
  );
});

export default IconListItem;
